export enum FilterIdEnum {
  DATE = 'date',
  REALTIME = 'realtime',

  LANG = 'lang',
  DEVICE = 'device',
  STORE = 'store',
  CATALOG = 'catalog',
  ATTRIBUTES = 'attributes',
  ATTRIBUTES_VALUE = 'attributes_value',

  COMPARE = 'compare',

  ENABLED = 'enabled',
  ACTIVE = 'active',
  ENDPOINT = 'endpoint',

  AUDIT_OBJECT_TYPE = 'objectType',
  AUDIT_ACTION = 'action',

  TYPE = 'type',

  UPDATED_ON = 'updatedOn',
  SCHEDULED = 'scheduled',
}
